// ─── src/types/chartLab.ts ────────────────────────────────────────────────────

export type ChartSource =
  | "registrations"
  | "mentors"
  | "report-leads"
  | "community-catalysts";
export type ChartType   = "donut" | "bar";

export interface ChartConfig {
  id:        string;
  source:    ChartSource;
  metric:    string;
  chartType: ChartType;
  title:     string;
}

export interface MetricOption {
  key:   string;
  label: string;
}

export const METRIC_OPTIONS: Record<ChartSource, MetricOption[]> = {
  registrations: [
    { key: "byCity",                 label: "By City" },
    { key: "byGender",               label: "By Gender" },
    { key: "byIdeaTheme",            label: "By Idea Theme" },
    { key: "pitchingIdea",           label: "Pitching Ideas" },
    { key: "requestingScholarship",  label: "Scholarship Requests" },
    { key: "availableAllDays",       label: "Availability" },
  ],
  mentors: [
    { key: "byTopic",     label: "By Topic" },
    { key: "byCity",      label: "By City" },
    { key: "byFrequency", label: "By Frequency" },
    { key: "byMode",      label: "By Mode" },
  ],
  "report-leads": [
    { key: "byReport", label: "By Report" },
  ],
  "community-catalysts": [
    { key: "byGender",      label: "By Gender" },
    { key: "byGovernorate", label: "By Governorate" },
    { key: "byTShirtSize",  label: "By T-Shirt Size" },
    { key: "bySession",     label: "By Session" },
  ],
};

export const SOURCE_LABELS: Record<ChartSource, string> = {
  registrations:       "Applicants",
  mentors:             "Mentors",
  "report-leads":      "Report Leads",
  "community-catalysts": "Catalysts",
};
